<div class="legal-page-wrapper">
  <!-- Navigation Header -->
  <div class="legal-page-header">
    <div class="header-content">
      <a href="/dashboard" class="logo-link">
        <img src="assets/img/logo.svg" alt="People Flow Logo" height="40" />
      </a>
    </div>
  </div>

  <div class="legal-document-container">
    <div class="legal-document-content">
      <h1>Podmínky používání služby People Flow</h1>

    <div class="document-metadata">
      <p><strong>Datum účinnosti:</strong> {{ effectiveDate }}</p>
      <p><strong>Verze:</strong> {{ version }}</p>
    </div>

    <section>
      <h2>Introduction</h2>
      <p>
        These Terms of Service ("Terms") govern your use of the People Flow Platform, Job Portal, and Website (collectively
        "People Flow Services"), operated by <strong>SAMETA s.r.o.</strong>, Čulenova 7936/5, 811 09 Bratislava, Company ID:
        50 706 667, registered in the Slovak Commercial Register (District Court Bratislava III, Insert No. 117160/B)
        ("People Flow", "we", "us", "our").
      </p>
      <p>
        By using any People Flow Services, you agree to be bound by these Terms. If you do not agree, please do not use our Services.
      </p>
      <p>
        These Terms are subject to change. The current version is always available at
        <a routerLink="/terms-of-use">this link</a>. By entering into an agreement with People Flow
        or by using the Services, you acknowledge that you have read, understood, and agree to be bound by these Terms.
      </p>
    </section>

    <section>
      <h2>Services Description</h2>
      <p>
        People Flow is a web-based platform that supports companies in managing recruitment processes, including job posting,
        candidate tracking, scheduling, document sharing, and communication. The Service consists of:
      </p>
      <ul>
        <li><strong>People Flow Platform:</strong> For companies and recruiters to manage hiring workflows.</li>
        <li><strong>People Flow Job Portal:</strong> For candidates to view and apply to job openings.</li>
        <li><strong>People Flow Website:</strong> Our representative site with information about our services.</li>
      </ul>
      <p>Further all as ("People Flow Service").</p>

      <h3>Provision of Service</h3>
      <p>
        Subject to these Terms, People Flow provides access to the Platform and Job Portal for Customer's internal recruitment
        and hiring management.
      </p>

      <h3>Access</h3>
      <p>
        Access is provided electronically. To use certain features, you may need to register for an account and provide accurate,
        complete information. You are responsible for maintaining the confidentiality of your login credentials and for all activity
        under your account.
      </p>

      <h3>No Equipment Provided</h3>
      <p>
        People Flow does not provide hardware, internet connection, or ancillary services necessary to access the Platform.
      </p>

      <h3>Service Modifications</h3>
      <p>
        People Flow may update, enhance, or modify the Platform from time to time. Customer acknowledges that functionality may
        evolve without compensation.
      </p>

      <h3>Subcontractors</h3>
      <p>
        People Flow may use subcontractors to deliver the Service, remaining responsible for their performance.
      </p>

      <h3>Feedback</h3>
      <p>
        People Flow may freely use feedback or suggestions to improve the Service without obligation to Customer.
      </p>
    </section>

    <section>
      <h2>Use of the Service</h2>

      <h3>Purpose</h3>
      <p>
        Customer may use the Service solely for its internal recruitment processes in accordance with these Terms.
      </p>

      <h3>User Accounts</h3>
      <p>
        Each User must be registered to a single email address. Accounts are personal and may not be shared.
      </p>

      <h3>Age Restriction</h3>
      <p>
        The Service is not intended for users under 18. Customer warrants no Users will be under 18.
      </p>

      <h3>Prohibited Use</h3>
      <p>Customer agrees not to:</p>
      <ul>
        <li>Create derivative works based on the Platform.</li>
        <li>Circumvent limits or restrictions.</li>
        <li>Reverse engineer or copy Platform components.</li>
        <li>Remove proprietary notices.</li>
        <li>Use the Service for illegal activities.</li>
        <li>Upload or transmit malicious code.</li>
        <li>Interfere with Service integrity or performance.</li>
      </ul>

      <h3>Disclaimer on Customer Data Storage</h3>
      <p>
        People Flow is not responsible for what personal data companies store about candidates, for how long, or whether they
        are authorized to do so. Each Customer is solely responsible for compliance with data retention obligations as a data controller.
      </p>

      <h3>Disclaimer on Uploaded Content</h3>
      <p>
        People Flow is not responsible for the content uploaded to the platform by candidates or HR staff. Customers and Users
        are solely responsible for the content they upload or share. People Flow has the right (but not the obligation) to remove
        content that violates these Terms or applicable laws.
      </p>

      <h3>No Responsibility for Company Data Practices</h3>
      <p>
        Companies using People Flow to manage their hiring processes act as data controllers. People Flow acts as a data processor
        on their behalf. People Flow does not guarantee or take responsibility for:
      </p>
      <ul>
        <li>What personal data companies store about candidates,</li>
        <li>For how long,</li>
        <li>Or whether they have a legal basis to do so.</li>
      </ul>
      <p>You should review the relevant company's privacy policies and practices independently.</p>
    </section>

    <section>
      <h2>Payment</h2>
      <p>
        Currently, People Flow Services are provided free of charge. We reserve the right to introduce paid features in the
        future with appropriate notice.
      </p>
    </section>

    <section>
      <h2>Warranties</h2>

      <h3>Mutual Warranties</h3>
      <p>
        Each Party warrants it is validly incorporated and has authority to enter into these Terms.
      </p>

      <h3>Service Availability</h3>
      <p>
        People Flow will use reasonable efforts to maintain availability of the Platform.
      </p>

      <h3>Disclaimer of Warranties</h3>
      <p class="disclaimer">
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE". PEOPLE FLOW DISCLAIMS ALL
        WARRANTIES, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING FITNESS FOR A PARTICULAR PURPOSE, MERCHANTABILITY,
        NON-INFRINGEMENT, OR SYSTEM INTEGRATION.
      </p>
    </section>

    <section>
      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, People Flow will not be liable for any indirect, incidental, special, consequential,
        or punitive damages arising from or relating to your use of the Services.
      </p>

      <h3>Force Majeure</h3>
      <p>
        Neither Party is liable for failure due to events beyond reasonable control.
      </p>
    </section>

    <section>
      <h2>Confidentiality</h2>

      <h3>Obligations</h3>
      <p>Each Party shall:</p>
      <ul>
        <li>Use Confidential Information only to fulfil obligations under these Terms.</li>
        <li>Restrict disclosure to those with a need to know and under confidentiality obligations.</li>
        <li>Protect Confidential Information with reasonable care.</li>
      </ul>

      <h3>Exceptions</h3>
      <p>Confidentiality obligations do not apply to information:</p>
      <ul>
        <li>Publicly available without breach.</li>
        <li>Lawfully obtained from a third party.</li>
        <li>Independently developed.</li>
        <li>Required to be disclosed by law (with notice where possible).</li>
      </ul>
    </section>

    <section>
      <h2>INTELLECTUAL PROPERTY AND DATA PROTECTION</h2>

      <h3>Intellectual Property</h3>
      <ul>
        <li>People Flow retains all rights to the Platform and its technology.</li>
        <li>Customer retains all rights to Customer Data.</li>
        <li>Customer grants People Flow a limited right to use Customer Data to provide the Service and improve functionality.</li>
        <li>Customer grants People Flow a limited right to use Customer's logo and name to identify them as a customer.</li>
      </ul>

      <h3>Data Processing</h3>
      <p>
        Processing of personal data is governed by the Data Processing Addendum which forms an integral part of this Terms.
        In case of conflict, these Terms prevail.
      </p>
    </section>

    <section>
      <h2>Governing Law</h2>
      <p>
        These Terms are governed by and construed in accordance with the laws of the Slovak Republic. Any disputes will be
        resolved by the courts of the Slovak Republic, unless mandatory legal provisions provide otherwise.
      </p>
    </section>

    <section>
      <h2>TERM, SUSPENSION, TERMINATION</h2>

      <h3>Term</h3>
      <p>
        The Term starts on the Effective Date and continues for the agreed period, or twelve (12) months if unspecified.
      </p>

      <h3>Renewal</h3>
      <p>
        The Agreement renews automatically unless either Party provides thirty (30) days' notice before expiry.
      </p>

      <h3>Suspension</h3>
      <p>
        People Flow may suspend access with notice if Customer materially breaches these Terms.
      </p>

      <h3>Termination for Cause</h3>
      <p>Either Party may terminate immediately if the other:</p>
      <ul>
        <li>Materially breaches and fails to cure within thirty (30) days.</li>
        <li>Becomes insolvent or subject to bankruptcy proceedings not dismissed within sixty (60) days.</li>
      </ul>

      <h3>Post-Termination</h3>
      <p>Upon termination:</p>
      <ul>
        <li>Each Party returns or destroys Confidential Information.</li>
        <li>Customer may request export of Customer Data within thirty (30) days.</li>
        <li>People Flow may permanently delete Customer Data after sixty (60) days.</li>
      </ul>
    </section>

    <section>
      <h2>Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Significant changes will be notified via our website or via email. Continued
        use of the Services after changes take effect constitutes acceptance of the updated Terms.
      </p>
    </section>

    <section>
      <h2>Contact</h2>
      <p>For any questions about these Terms, please contact us at:</p>
      <p>
        <strong>SAMETA s.r.o.</strong><br>
        Čulenova 7936/5<br>
        811 09 Bratislava<br>
        Email: <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      </p>
    </section>

    <section class="dpa-section">
      <h2>DATA PROCESSING ADDENDUM</h2>

      <h3>INITIAL PROVISIONS</h3>
      <p>
        This Data Processing Addendum forms an integral part of the Agreement and is referenced in the Agreement.
      </p>
      <p>
        By entering into the Agreement with People Flow, You, the Customer, acknowledge that you have read and understood this
        Data Processing Addendum and agree to be bound by it.
      </p>

      <!-- TODO: Add complete definitions section with all capitalized terms used in the DPA. -->
      <!-- <div class="todo-note">
        <p><strong>TODO:</strong> Add complete definitions section with all capitalized terms used in the DPA.</p>
      </div> -->

      <h3>PEOPLE FLOW'S OBLIGATIONS</h3>

      <h4>Roles</h4>
      <p>
        For the purposes of the GDPR and similar Data Protection Legislation, Customer (or third party on whose behalf Customer
        is authorised to instruct People Flow) is the Controller of Customer Data that are Personal Data, and People Flow shall
        Process Personal Data as a Processor (or sub-Processor, as applicable to Customer's use of Service).
      </p>

      <h4>Permitted Purposes</h4>
      <p>
        People Flow shall Process Personal Data for the purposes described in Annex A and in accordance with Customer's documented
        lawful instructions ("Permitted Purposes"), except where otherwise required by law(s) that are not incompatible with
        applicable Data Protection Legislation. To the extent required by Data Protection Legislation, this Clause 3.2 constitutes
        the certification from People Flow to the Processing instructions herein. People Flow is obliged at all times to Process
        Personal Data in compliance with Data Protection Legislation and fulfil all its obligations arising out of Data Protection
        Legislation.
      </p>

      <h4>Processing Instructions</h4>
      <p>
        People Flow shall immediately inform Customer if it becomes aware that Customer's Processing instructions infringe Data
        Protection Legislation. If People Flow is unable to Process Personal Data in accordance with the Customer's documented
        lawful instructions, People Flow is obliged to promptly notify Customer of its inability to comply.
      </p>

      <h4>Security Measures</h4>
      <p>
        People Flow shall implement and maintain reasonable and appropriate technical and organisational measures designed to
        protect all data, including Personal Data, from Data Breaches and preserve their security, integrity, and confidentiality.
        Such measures shall have regard to the state of the art, the costs of implementation and the nature, scope, context, and
        purposes of Processing, as well as the risk of varying likelihood and severity for the rights and freedoms of natural
        persons. At a minimum, these measures must include the measures identified in Annex C of this Data Processing Addendum.
      </p>

      <h4>Access and Confidentiality</h4>
      <p>
        People Flow shall ensure that any person it authorises to Process the Personal Data (including People Flow' staff, agents
        and Sub-processor's) ("Personnel") are under appropriate obligations of confidentiality (whether a contractual or statutory
        duty), have received proper training, and are informed about the confidential nature of the Personal Data and their
        obligations related to it and have access to Personal Data only in accordance with the need-to-know principle. People Flow
        shall ensure that all Personnel Process the Personal Data only as necessary for the Permitted Purposes.
      </p>

      <h4>Data Returns and Deletion</h4>
      <p>
        Upon termination or expiration of the Agreement, People Flow must delete or return to Customer all Personal Data (including
        copies) in its possession or control in accordance with the Agreement.
      </p>

      <h4>Audit Rights</h4>
      <p>
        Customer shall have the right to conduct an audit to verify People Flow's compliance with its obligations laid down in
        Art. 28 GDPR (if applicable) and in this Addendum. People Flow shall allow the Customer to carry out the audit under the
        following conditions:
      </p>
      <ul>
        <li>Customer asks People Flow to carry out the audit via a written notice at least 30 (thirty) days in advance;</li>
        <li>Customer will specify the agenda for such audit in the notification;</li>
        <li>the audit shall not take place more than once a year;</li>
        <li>all associated costs and expenses shall be borne by Customer and reimbursed to People Flow on demand; and</li>
        <li>the audit shall last no longer than the equivalent of 1 working day (8 hours) of the People Flow representative.</li>
      </ul>
      <p>
        In case Customer requests the audit via third independent party – external licensed auditor, People Flow may object to
        an external licensed auditor appointed by Customer to conduct the audit if the auditor is, in People Flow's reasonable
        opinion, not suitably qualified or independent, a competitor of People Flow, or otherwise manifestly unsuitable. Any such
        objection will require Customer to appoint another auditor. In case Customer requires more than one audit within one
        calendar year, Customer shall obtain prior written permission of People Flow and shall bear the cost associated with such
        audits and reimburse People Flow all reasonably incurred costs of such audits. On the request of Customer, People Flow
        will provide Customer with the estimated cost that it expects to incur during such audit according to the extent specified
        in the agenda provided by Customer.
      </p>

      <h3>CUSTOMER'S OBLIGATIONS</h3>

      <h4>Customer's Processing of Personal Data</h4>
      <p>
        Customer shall, in its use of Service, Process Personal Data in accordance with Data Protection Legislation. Customer
        shall have the sole responsibility for the accuracy, quality, and legality of Personal Data and how Customer acquired
        Personal Data.
      </p>

      <h4>Customer's Compliance</h4>
      <p>Customer agrees that:</p>
      <ul>
        <li>it shall comply with its obligations as a Controller under Data Protection Legislation in respect of its Processing
        of Personal Data and any Processing instructions it issues to People Flow;</li>
        <li>it has provided notice and obtained (or shall obtain) all consents or any other necessary authorisations (as applicable)
        under Data Protection Legislation for People Flow to Process Personal Data for the Permitted Purposes;</li>
        <li>it shall be responsible for providing any notices required by Data Protection Legislation to its Users and other relevant
        data subjects with respect to sharing their Personal Data with People Flow;</li>
        <li>it has fulfilled (or shall fulfil) all registration or notification obligations to which Customer is subject to under
        the Data Protection Legislation; and</li>
        <li>it is responsible for its own Processing of Personal Data, including integrity, security, maintenance and appropriate
        protection of Personal Data under Customer's control.</li>
      </ul>

      <h4>Technical and Organisational Measures</h4>
      <p>
        Customer is responsible for its secure use of Service, including securing the Admin/User Account, protecting the security
        of Personal Data when in transit to and from Service and taking any appropriate technical, organisational and security
        measures to securely encrypt or backup any Personal Data uploaded to Service. Customer is also responsible for the use
        of Service by any person the Customer authorised to access or use Service, and any person who gains access to its Personal
        Data or the Service as a result of its failure to use reasonable security precautions, even if Customer did not authorise
        such use. Customer agrees to, immediately upon awareness, notify People Flow of any unauthorised use of Service or the
        Admin/User Account or of any other breach of security involving Service.
      </p>

      <h3>COOPERATION</h3>

      <h4>Data Subject Rights</h4>
      <p>
        To the extent that Customer is unable to access the relevant Personal Data within Service independently, People Flow shall,
        taking into account the nature of the Processing, provide assistance (including by appropriate technical and organisational
        measures) to provide reasonable cooperation to Customer in order to:
      </p>
      <ul>
        <li>respond to any requests from a data subject seeking to exercise any of its rights under Data Protection Legislation
        (including its right of access, correction, objection, erasure and data portability, as applicable); and</li>
        <li>any other correspondence, enquiry or complaint received from a data subject, regulator or other third party in connection
        with the Processing of the Personal Data (collectively "Correspondence").</li>
      </ul>
      <p>
        In the event that any such Correspondence is made directly to People Flow, it shall promptly notify Customer and shall
        not respond directly unless legally completed to do so. If People Flow is required to respond to such Correspondence,
        People Flow shall promptly notify Customer and provide it with a copy of the request, unless legally prohibited from doing so.
      </p>

      <h4>Data Protection Impact Assessment</h4>
      <p>
        To the extent required by Data Protection Legislation, People Flow shall provide reasonable cooperation regarding Service
        to enable Customer to carry out data protection impact assessments or prior consultations with data protection authorities
        as required by Data Protection Legislation.
      </p>

      <h4>Request for Disclosure</h4>
      <p>
        People Flow is obliged to promptly notify Customer about any legally binding request for disclosure of the personal data
        by a judicial or regulatory authority unless otherwise prohibited, such as the obligation under criminal law to preserve
        the confidentiality of a judicial enquiry and to assist Customer therewith (at Customer's expense).
      </p>

      <h3>SECURITY INCIDENTS</h3>

      <h4>Data Breach</h4>
      <p>
        Upon becoming aware of a Data Breach, People Flow shall notify Customer without undue delay and shall provide such timely
        information and cooperation as Customer may reasonably require in order to fulfil its data breach reporting obligations
        under Data Protection Legislation, including the type of data affected and the identity of the affected person(s) as soon
        as such information becomes known or available to People Flow.
      </p>

      <h4>No Acknowledgement</h4>
      <p>
        Customer agrees that any notification that People Flow provides to Customer in relation to a Data Breach shall not be
        construed or understood as an acknowledgement of any fault or liability.
      </p>

      <h4>Further Conduct</h4>
      <p>
        People Flow shall further take all such measures and actions as are reasonable to remedy or mitigate the effects of the
        Data Breach and shall keep Customer informed of all developments in connection with the Data Breach.
      </p>

      <h4>Cooperation</h4>
      <p>
        If a Data Breach is caused or materially contributed to by the Customer, People Flow will cooperate in the investigation
        of the Data Breach subject to Customer's obligation to compensate People Flow for its expenses and costs.
      </p>

      <h3>SUB-PROCESSING</h3>

      <h4>Authorised Sub-processors</h4>
      <p>
        Customer provides a general authorisation for People Flow to engage Sub-processors to Process Personal Data on Customer's
        behalf. The Sub-processors currently engaged by People Flow are listed in Annex B.
      </p>

      <h4>New Sub-processors</h4>
      <p>
        People Flow shall provide at least 10 days prior written notice to the Customer of the engagement of any new Sub-processor
        (including details of the Processing and location), whereas People Flow provides such notifications to Customer via the
        <a routerLink="/subprocessors">List of Subprocessors</a> page on People Flow's website. It is the responsibility of the
        Customer to regularly check this page for updates.
      </p>
      <!-- TODO: Decide between RSS Feed or subscription notification system. Update the text accordingly and implement the chosen solution. -->
      <!-- <div class="todo-note">
        <p>
          <strong>TODO:</strong> Decide between RSS Feed or subscription notification system. Update the text accordingly and
          implement the chosen solution.
        </p>
      </div> -->

      <h4>Objections</h4>
      <p>
        If Customer has a reasonable objection to any new sub-processor, it shall notify People Flow of such objections in writing
        to {{ supportEmail }} within ten (10) days from receiving the notification and the
        Parties will seek to resolve the matter in good faith. If Customer does not provide a timely objection to any new
        sub-processor in accordance with this Section 8.3, Customer will be deemed to have consented to the sub-processor and
        waived its right to object.
      </p>

      <h4>Liability for Sub-processors</h4>
      <p>
        People Flow remains fully liable for any breach of this Data Processing Addendum or the Agreement caused by an act, error
        or omission of such Sub-processor.
      </p>

      <h3>DATA TRANSFERS</h3>

      <h4>International Data Transfers</h4>
      <p>
        People Flow shall take all such measures necessary to ensure that the Processing and transfer of Personal Data in or to
        a territory other than the territory in which the Personal Data was first collected complies with Data Protection Legislation.
      </p>

      <h4>Application of Standard Contractual Clauses</h4>
      <p>
        The Parties agree that when and to the extent the transfer of Personal Data from Customer to People Flow is a Restricted
        Transfer and EU Data protection Law requires that appropriate safeguards are put in place, such transfer shall be governed
        by the EU SCCs, which shall be incorporated by reference into and form an integral part of this DPA as follows:
      </p>
      <p>For the purposes of Personal Data that is subject to the EU Data Protection Laws ("EU Data"):</p>
      <ul>
        <li>Where Customer is a Controller of Personal Data, Module Two (Controller to Processor Clauses) will apply and where
        Customer is a Processor acting on behalf of third-party Controllers, Module 3 (Processor to Processor Clauses) will apply;</li>
        <li>in Clause 7 (Docking Clause), the optional docking clause will apply;</li>
        <li>in Clause 9 (Use of Sub-processors), Option 2 will apply, and the time period for prior notice of sub-processor changes
        shall be as set out in Clause 8.2. of this DPA and the period for notification of objections in Clause 8.3. of this PDA;</li>
        <li>in Clause 11 (Redress), the optional language to permit data subjects to lodge complaints with an independent dispute
        resolution body will not apply;</li>
        <li>in Clause 17 (Governing Law), Option 1 will apply, and the EU SCCs will be governed by Slovak law;</li>
        <li>in Clause 18(b) (Choice of forum and jurisdiction), disputes shall be resolved before the courts of Slovak Republic;</li>
      </ul>

      <h3>LIMITATION OF LIABILITY</h3>
      <p>
        Customer's remedies, including its Affiliates, and People Flow's liability arising out of or in relation to this Data
        Processing Addendum (including Standard Contractual Clauses), are subject to those limitations of liability and disclaimers
        set forth in the Agreement. For the avoidance of doubt, nothing in this DPA is intended to limit the rights a Data Subject
        may have against either Party arising out of such Party's breach of the Standard Contractual Clauses, where applicable.
      </p>

      <h3>FINAL PROVISIONS</h3>

      <h4>Third-Party Beneficiaries</h4>
      <p>
        Data Subjects are the sole third-party beneficiaries to the Standard Contractual Clauses, and there are no other third-party
        beneficiaries to the Agreement and this Data Processing Addendum.
      </p>

      <h4>Governing Law and Jurisdiction</h4>
      <p>
        This Data Processing Addendum shall be governed by and construed with governing law and jurisdiction provisions in the
        Agreement, unless and to the extent required otherwise by the Data Protection Legislation or the Standard Contractual Clauses.
      </p>

      <h4>Scope of this Data Processing Addendum</h4>
      <p>
        For the avoidance of doubt, the processing of information other than Personal Data for the Permitted Purposes does not
        fall under the scope of this Data Processing Addendum.
      </p>

      <h4>Term</h4>
      <p>
        This Data Processing Addendum shall continue to be in effect for the term of the Agreement plus the period from expiry
        of the Agreement until People Flow ceases to process Personal Data on behalf of Customer.
      </p>

      <div class="annexes">
        <h3>ANNEXES</h3>

        <div class="annex-box">
          <h4>Annex A: Description of the Processing Activities / Transfer</h4>

          <h5>Annex A(1) List of Parties:</h5>
          <table class="parties-table">
            <thead>
              <tr>
                <th>Data Exporter</th>
                <th>Data Importer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Name:</strong> Customer</td>
                <td><strong>Name:</strong> SAMETA s.r.o.</td>
              </tr>
              <tr>
                <td><strong>Address:</strong> As identified in the Order</td>
                <td><strong>Address:</strong> Čulenova 7936/5, 811 09 Bratislava</td>
              </tr>
              <tr>
                <td><strong>Contact details:</strong> As identified in the Order</td>
                <td><strong>Contact details:</strong> {{ supportEmail }}</td>
              </tr>
              <tr>
                <td><strong>Activities relevant to the transfer:</strong> See Annex A(2) below</td>
                <td><strong>Activities relevant to the transfer:</strong> See Annex A(2) below</td>
              </tr>
              <tr>
                <td><strong>Role:</strong> Controller</td>
                <td><strong>Role:</strong> Processor</td>
              </tr>
            </tbody>
          </table>

          <h5>Annex A(2) Description of Transfer:</h5>
          <table class="transfer-table">
            <tbody>
              <tr>
                <td><strong>Categories of data subjects:</strong></td>
                <td>
                  <ul>
                    <li>Candidates applying via the People Flow Job Portal.</li>
                    <li>HR Users (recruiters, hiring managers) with company accounts on the People Flow Platform.</li>
                    <li>Company administrators managing recruitment data.</li>
                    <li>Any other individuals whose Personal Data is uploaded or processed in the platform (e.g. references in CVs).</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><strong>Categories of personal data:</strong></td>
                <td>
                  <ul>
                    <li>Identification and contact data (name, email, phone, address)</li>
                    <li>Professional and educational background (work history, skills, education)</li>
                    <li>Application metadata (position applied for, status, submission timestamps)</li>
                    <li>Uploaded documents (CV, cover letter, certificates)</li>
                    <li>Communication metadata (emails, calendar invites)</li>
                    <li>Authentication data (email/password hashes, Google SSO tokens)</li>
                    <li>Notification data (alerts about application statuses)</li>
                    <li>Audit logs (user ID, action, timestamp)</li>
                    <li>Usage and device data (IP address, browser info, system logs)</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><strong>Sensitive data:</strong></td>
                <td>
                  People Flow does not require any special categories of data to provide Service and does not intentionally
                  collect or process such data in connection with the provision of Service. However, documents or free-text
                  fields may include special categories of data if users voluntarily provide them (e.g. disability info,
                  racial or ethnic origin in CVs).
                </td>
              </tr>
              <tr>
                <td><strong>Frequency of the transfer:</strong></td>
                <td>Continuous</td>
              </tr>
              <tr>
                <td><strong>Nature and subject matter of processing:</strong></td>
                <td>
                  The Personal Data may be subject to the following processing activities:
                  <ul>
                    <li>Secure storage (AWS S3) of uploaded candidate documents.</li>
                    <li>Authentication (Firebase Auth, Google SSO).</li>
                    <li>Email/calendar integration (Gmail API, Google Calendar API).</li>
                    <li>Document parsing, AI-based structuring (OpenAI, MistralAI) with pseudonymization.</li>
                    <li>User management and role-based access controls.</li>
                    <li>Logging of activity for audit/compliance.</li>
                    <li>Analytics for improving platform features, with pseudonymization and data minimization.</li>
                    <li>Notifications and communication facilitation (Gmail, Google Calendar).</li>
                    <li>Error monitoring and diagnostics (Sentry).</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><strong>Duration of the processing:</strong></td>
                <td>Processing Term.</td>
              </tr>
              <tr>
                <td><strong>Purpose(s) of the data transfer and further processing:</strong></td>
                <td>
                  <ul>
                    <li>Providing, maintaining, supporting, and improving the People Flow Platform.</li>
                    <li>Supporting the recruitment process, including candidate management and communication.</li>
                    <li>Enabling AI-powered CV parsing and structuring (with pseudonymization before external API use).</li>
                    <li>Ensuring platform security, integrity, and auditability.</li>
                    <li>Performing analytics to understand labor market trends and improve service (using aggregated or pseudonymized data).</li>
                    <li>Complying with legal obligations.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><strong>Retention period:</strong></td>
                <td>
                  <ul>
                    <li>Personal Data is retained for the term of the Agreement plus legally required periods.</li>
                    <li>Candidate data retained in line with agreed retention policies (e.g. 6–12 months after process completion, unless consent for longer storage is given).</li>
                    <li>Minimal audit logs retained for legal defense (e.g. 12 months for discrimination claims).</li>
                    <li>Consent records retained for 24 months.</li>
                    <li>System logs retained for security analysis (e.g. 6 months).</li>
                    <li>Pseudonymized analytics retained as long as necessary for service improvement.</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <h5>Annex A(3): Competent supervisory authority</h5>
          <p>
            With respect to EU Data the competent supervisory authority is the <strong>Slovak Data Protection Authority
            (the "Slovak DPA")</strong>.
          </p>
        </div>

        <div class="annex-box">
          <h4>Annex B: Approved Sub-processors</h4>

          <table class="subprocessors-table">
            <thead>
              <tr>
                <th>Sub-processor</th>
                <th>Processing Activity</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Firebase (Google)</strong></td>
                <td>User authentication (Firebase Auth)</td>
              </tr>
              <tr>
                <td><strong>AWS (S3, Parameter Store, Secrets Manager, IAM)</strong></td>
                <td>File storage, secure configuration management, and infrastructure access control</td>
              </tr>
              <tr>
                <td><strong>Google API (Gmail & Calendar)</strong></td>
                <td>
                  <ul>
                    <li><strong>Gmail API:</strong> Sending and receiving emails with candidates</li>
                    <li><strong>Google Calendar API:</strong> Scheduling interviews with candidates during the recruitment process</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><strong>Sentry</strong></td>
                <td>Error monitoring and logging</td>
              </tr>
              <tr>
                <td><strong>OpenAI API</strong></td>
                <td>Language model embeddings generation and structured data extraction</td>
              </tr>
              <tr>
                <td><strong>MistralAI API</strong></td>
                <td>Language model embeddings generation</td>
              </tr>
              <tr>
                <td><strong>Vercel</strong></td>
                <td>Frontend deployment</td>
              </tr>
            </tbody>
          </table>

          <p style="margin-top: 1.5rem;">
            The complete and up-to-date list of subprocessors with detailed information (entity details, location/jurisdiction,
            types of personal data processed) is available on our
            <a routerLink="/subprocessors">List of Subprocessors</a> page.
          </p>
        </div>

        <div class="annex-box">
          <h4>Annex C: Technical and Organisational Measures</h4>
          <p>
            The technical and organisational measures implemented by People Flow (including any relevant certifications) to
            ensure an appropriate level of security taking into account the nature, scope, context, and purposes of the processing,
            and the risks for the rights and freedoms of natural persons, are described below.
          </p>

          <table class="measures-table">
            <thead>
              <tr>
                <th>Type of measure</th>
                <th>Implemented measure</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Measures of pseudonymisation and encryption of personal data</strong></td>
                <td>
                  Pseudonymization of text data before sending to external AI APIs; HTTPS/TLS encryption for data in transit;
                  encryption of data at rest on AWS S3.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring ongoing confidentiality of processing systems and Service</strong></td>
                <td>
                  Role-based access controls; OAuth 2.0 / JWT for user sessions; separate environments for staging/production.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring ongoing integrity of processing systems and Service</strong></td>
                <td>
                  Input validation; strict logging of data changes; code reviews.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring ongoing availability and resilience of processing systems and Service</strong></td>
                <td>
                  AWS cloud redundancy; automatic scaling; database backups.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring the ability to restore the availability and access to personal data in a timely
                manner in the event of a physical or technical incident</strong></td>
                <td>
                  Automated daily backups; defined disaster recovery plan.
                </td>
              </tr>
              <tr>
                <td><strong>Processes for regularly testing, assessing and evaluating the effectiveness of technical and
                organisational measures in order to ensure the security of the processing</strong></td>
                <td>
                  Security audits; vulnerability scanning; monitoring via Sentry.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for user identification and authorisation</strong></td>
                <td>
                  Firebase Auth, Google SSO, Apple SSO; strict session management.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for the protection of Data during storage</strong></td>
                <td>
                  Encrypted storage on AWS S3; access limited to authorized services.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring physical security of locations at which personal data are processed</strong></td>
                <td>
                  AWS and Google Cloud data centers with certified physical security.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring events logging</strong></td>
                <td>
                  Audit logs of user actions; monitoring of admin access.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring system configuration, including default configuration</strong></td>
                <td>
                  Secure defaults; minimal access permissions; CI/CD with approvals.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for internal IT and IT security governance and management</strong></td>
                <td>
                  Developer training; security policy enforcement.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring data minimisation</strong></td>
                <td>
                  Only necessary data collected; optional fields clearly marked.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring data quality</strong></td>
                <td>
                  Validation of user input; user access to update data.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring limited data retention</strong></td>
                <td>
                  Retention policies aligned with legal needs; deletion workflows with user-triggered account deletion.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for ensuring accountability</strong></td>
                <td>
                  Documented privacy policies and procedures.
                </td>
              </tr>
              <tr>
                <td><strong>Measures for allowing data portability and ensuring erasure</strong></td>
                <td>
                  User interface for data access and account deletion; manual support via email.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    </div>
  </div>
</div>
